import React from "react";

import { type FlowItemEmbeddedVideo } from "../../../../features/Library/Flows/Designer/types";

import TopContent from "../BaseCard/TopContent";
import BottomContent from "../BaseCard/BottomContent";

export interface IEmbeddedVideoCardOwnProps {
  item: FlowItemEmbeddedVideo;
}

const EmbeddedVideoCard: React.FC<IEmbeddedVideoCardOwnProps> = ({ item }) => (
  <>
    <TopContent {...item} />
    <BottomContent cardLabel={"Embedded Video"} />
  </>
);

export default EmbeddedVideoCard;
